<template>
  <div key="contentLoader" class="p-3">
    <vue-content-loading :speed="1" :height="65" class="mb-1">
      <rect x="0" y="5" rx="4" ry="4" width="100%" height="55" />
    </vue-content-loading>
    <vue-content-loading :speed="1" :height="65" class="mb-1">
      <rect x="0" y="5" rx="4" ry="4" width="100%" height="55" />
    </vue-content-loading>
    <vue-content-loading :speed="1" :height="65" class="mb-1">
      <rect x="0" y="5" rx="4" ry="4" width="100%" height="55" />
    </vue-content-loading>
  </div>
</template>

<script>
export default {
  name: 'JobContentLoading',
};
</script>
